import { Callout } from "$components/callout";
import { useConvertFromPenceFactory } from "$routes/_lib/use-convert-currency";
import useCurrencyFormat from "$routes/_lib/use-currency-format";
import { styled } from "@material-ui/core";
import { FormattedMessage } from "react-intl";

const Banner = styled(Callout)(({ theme }) => ({
  marginBottom: theme.spacing(2),
}));

export const OutstandingBanner: FC<{ formattedAmount: string }> = ({
  formattedAmount,
}) => (
  <Banner type="warning" data-testid="outstanding-banner">
    <FormattedMessage
      id="invoicing.v2.outstandingBanner"
      defaultMessage="Outstanding balance of {amount}"
      values={{ amount: <strong>{formattedAmount}</strong> }}
    />
  </Banner>
);

export const useFormatOutstandingTotal = () => {
  const currency = useCurrencyFormat();
  const convertFromPence = useConvertFromPenceFactory();
  return (totalDueInPence: number) =>
    currency.format(convertFromPence(totalDueInPence));
};
